import { createBrowserRouter } from "react-router";
import { articlesRoutes } from "@/features/articles";
import { bookingRoutes } from "@/features/booking";
import { galleryRoutes } from "@/features/gallery";
import { HomePage } from "@/features/home";
import { myAppointmentsRoutes } from "@/features/my-appointments";
import { branchBasename } from "@/lib/branch";
import { NotFoundPage } from "@/shared/components/NotFoundPage";
import { RouteErrorPage } from "@/shared/components/RouteErrorPage";
import { AppLayout } from "@/shared/layout/AppLayout";

/**
 * Public by default, which is the whole difference from the staff app.
 *
 * Nothing sits behind an authentication guard at the router level: a customer should be able to
 * read the catalogue, see the opening hours and check availability without an account, and only
 * meet a sign-in when they commit to something. The screens that need a customer say so themselves
 * with `RequireCustomer`, which offers sign-in in place rather than redirecting.
 */
export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    errorElement: <RouteErrorPage />,
    children: [
      { index: true, element: <HomePage /> },
      // On demand, like the booking flow: not part of the home page's first paint (NFR-SA-009).
      { path: "account", lazy: async () => ({ Component: (await import("@/features/account/AccountPage")).AccountPage }) },
      ...bookingRoutes,
      ...myAppointmentsRoutes,
      ...articlesRoutes,
      ...galleryRoutes,
      // scaffold:routes
      { path: "*", element: <NotFoundPage /> },
    ],
  },
],
// The branch a booking link names is the base of every path, so the app's links stay inside it (FR-SA-245).
{ basename: branchBasename });
